import { Button, Dialog, DialogActions, DialogContent, DialogTitle, TextField } from '@mui/material'
import React from 'react'
import { i18n } from '../index'
import type { PlanNote } from './types'
type Props = {
  isOpen: boolean
  onClose: (...args: Array<any>) => any
  stationId: string
  dailyNote: PlanNote
  onSave: (...args: Array<any>) => any
}
type State = {
  note: string
}

class NoteDialog extends React.Component<Props, State> {
  constructor(props) {
    super(props)
    this.state = {
      note: props.dailyNote ? props.dailyNote.note : '',
    }
  }

  componentDidUpdate(prevProps) {
    if (this.props.dailyNote && prevProps.dailyNote !== this.props.dailyNote) {
      this.setState({
        note: this.props.dailyNote.note,
      })
    }
  }

  onDialogClose = () => {
    this.setState({
      note: '',
    })
    this.props.onClose()
  }
  handleSaveNote = () => {
    const { dailyNote, stationId, onSave } = this.props
    const { date } = dailyNote
    const { note } = this.state
    const noteInput = {
      date,
      stationId,
      note,
    }

    if (dailyNote.id) {
      Object.assign(noteInput, {
        id: dailyNote.id,
      })
    }

    onSave(noteInput)
    this.onDialogClose()
  }

  render() {
    const { isOpen, onClose } = this.props
    const { note } = this.state
    return (
      <Dialog open={isOpen} onClose={onClose} maxWidth={'sm'} fullWidth>
        <DialogTitle>{i18n.t('budgetPlanning.noteDialog.title')}</DialogTitle>

        <DialogContent>
          <TextField
            id={'note'}
            label={i18n.t('budgetPlanning.noteDialog.noteInputLabel')}
            value={note}
            onChange={(e) =>
              this.setState({
                note: e.target.value,
              })
            }
            multiline
            autoFocus
            fullWidth
          />
        </DialogContent>

        <DialogActions
          style={{
            padding: '0 15px 15px 0',
          }}
        >
          <Button color={'primary'} variant={'contained'} onClick={this.handleSaveNote}>
            {i18n.t('budgetPlanning.noteDialog.saveButton')}
          </Button>

          <Button variant={'contained'} onClick={this.onDialogClose}>
            {i18n.t('budgetPlanning.noteDialog.cancelButton')}
          </Button>
        </DialogActions>
      </Dialog>
    )
  }
}

export default NoteDialog
